export default function toSnakeCase(str) {
    return str
      .replace(/\s+/g, ' ')                 // Normalize spaces
      .trim()                                // Remove leading/trailing spaces
      .replace(/([a-z])([A-Z])/g, '$1_$2')  // Handle camelCase
      .replace(/[^a-zA-Z0-9\s]/g, '')        // Remove special characters
      .replace(/\s+/g, '_')                  // Replace spaces with underscores
      .toLowerCase();
  }